<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloCrud}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioPaciente" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                            <mat-label>Nome</mat-label>
                            <input matInput value="Nome" class="form-control" id="nome" required trim="blur" name="nome"
                                formControlName="nome" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioPaciente.controls.nome.hasError('required')">
                                O campo Nome é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioPaciente.controls.nome.hasError('minlength')">
                                O campo Nome precisa conter mais do que 5 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>CPF</mat-label>
                            <input matInput value="CPF" class="form-control" id="cpf" trim="blur" name="cpf"
                                formControlName="cpf" maxlength="14" trim="blur" nccCpfCnpjMask required>
                            <mat-error *ngIf="formularioPaciente.controls.cpf.errors">
                                O campo CPF está inválido.
                            </mat-error>
                            <mat-error *ngIf="formularioPaciente.controls.cpf.hasError('required')">
                                O campo CPF é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Data Nasc.</mat-label>
                            <input matInput [matDatepicker]="dataNascimentoDP" formControlName="dataNascimento"
                                id="dataNascimento" name="dataNascimento">
                            <mat-datepicker-toggle matSuffix [for]="dataNascimentoDP"></mat-datepicker-toggle>
                            <mat-datepicker #dataNascimentoDP></mat-datepicker>

                            <mat-error *ngIf="formularioPaciente.controls.dataNascimento.hasError('required')">
                                O campo Data Nasc. é obrigatório.
                            </mat-error>

                            <mat-error *ngIf="formularioPaciente.controls.dataNascimento.hasError('invalidDate')">
                                O campo Data Nasc. está inválido.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Fone Residencial</mat-label>
                            <input matInput value="Fone Residencial" class="form-control"
                                id="foneResidencial" name="foneResidencial" phoneMask [maskInputId]="'foneResidencial'"
                                [preValue]="formularioPaciente.value.foneResidencial"
                                [phoneControl]="formularioPaciente.controls['foneResidencial']"
                                formControlName="foneResidencial" minlength="14" maxlength="16">
                            <mat-error *ngIf="formularioPaciente.controls.foneResidencial.errors">
                                O campo Fone Residencial está inválido.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Núm. Celular</mat-label>
                            <input matInput value="Núm. Celular" class="form-control" id="foneCelular"
                                name="foneCelular" phoneMask [maskInputId]="'foneCelular'"
                                [preValue]="formularioPaciente.value.foneCelular"
                                [phoneControl]="formularioPaciente.controls['foneCelular']"
                                formControlName="foneCelular" minlength="14" maxlength="16">
                            <mat-error *ngIf="formularioPaciente.controls.foneCelular.errors">
                                O campo Núm. Celular está inválido.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="card">
                        <div class="card-header">Dependentes</div>
                        <div class="card-body" style="padding-bottom: 0px;">
                            <table class="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">Nome</th>
                                        <th scope="col">Data Nasc.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let dependente of dependentes; let i = index"
                                        (click)="onClickNaTabelaDeDependente(i)"
                                        [class.active]="i == numeroDaLinhaSelecionadaNaTabelaDeDependente">
                                        <td>{{dependente.nome}}</td>
                                        <td>{{dependente.dataNascimento | date:"dd/MM/yyyy"}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12" style="text-align: right;">
                                <button type="button" mat-button color="primary" matTooltip="Novo"
                                    style="margin-right: 20px;" (click)="navegarParaTelaDeCadastroDeDependente()"
                                    [disabled]="isInfo">
                                    Novo Dependente
                                </button>
                                <!--
                                <button type="button" mat-button color="warn" matTooltip="Remover"
                                    style="margin-right: 20px;"
                                    [disabled]="isInfo || numeroDaLinhaSelecionadaNaTabelaDeDependente == -1"
                                    (click)="removerDependenteSelecionado()">
                                    Remover Dependente
                                </button>
                                -->
                            </div>
                        </div>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioPaciente.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="gotoList()" matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>